import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class ScreeningStatus extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;
}
